import React from 'react';

import { useIntl } from 'react-intl';

import { HomePage } from 'components/features/home-page';
import { PageAnnouncer } from 'components/page-announcer';
import { PromoMessageRibbon } from 'pages/loyalty/loyalty-promo-message-ribbon';

const Home = () => {
  const { formatMessage } = useIntl();
  return (
    <>
      <PromoMessageRibbon />
      <HomePage />
      <PageAnnouncer pageTitle={formatMessage({ id: 'homepage' })} />
    </>
  );
};

export default React.memo(Home);
